import { styled } from '../theme';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.palette.general.lightGrey[60]};
`;
